/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BusinessData } from '../models/BusinessData';
import type { PaginatedResponse_PerformanceResponse_ } from '../models/PaginatedResponse_PerformanceResponse_';
import type { PerformanceCreateRequest } from '../models/PerformanceCreateRequest';
import type { PerformanceFullCreateRequest } from '../models/PerformanceFullCreateRequest';
import type { PerformanceFullResponse } from '../models/PerformanceFullResponse';
import type { PerformanceFullUpdateRequest } from '../models/PerformanceFullUpdateRequest';
import type { PerformanceResponse } from '../models/PerformanceResponse';
import type { PerformanceUpdateRequest } from '../models/PerformanceUpdateRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PerformanceService {
    /**
     * Get Workspace Performance All
     * 워크스페이스 전체 성과 조회
     *
     * 워크스페이스의 전체 성과 데이터를 계층적 구조로 조회합니다.
     * Business → PerformanceGroup → PerformanceCategory (재귀) → PerformanceClass → Performance
     *
     * Args:
     * workspace_id: 워크스페이스 ID (필수)
     *
     * Returns:
     * List[BusinessData]: 사업 목록 (각 사업은 성과 그룹, 분류, 지표, 성과를 포함)
     * @returns BusinessData OK
     * @throws ApiError
     */
    public static appsPerformanceViewsGetWorkspacePerformanceAll({
        workspaceId,
    }: {
        workspaceId: string,
    }): CancelablePromise<Array<BusinessData>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/performance/workspace-all',
            query: {
                'workspace_id': workspaceId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create Performance Full
     * 성과 전체 생성 (Performance + PerformanceMap + PerformanceItems)
     *
     * 한 번의 요청으로 Performance, PerformanceMap, PerformanceItems를 모두 생성합니다.
     * PerformanceMap의 link_type은 "direct"로 설정되고, target_id는 생성된 Performance ID로 설정됩니다.
     * 모든 작업은 트랜잭션으로 처리되어 전체 성공 또는 전체 실패를 보장합니다.
     * @returns PerformanceFullResponse Created
     * @throws ApiError
     */
    public static appsPerformanceViewsCreatePerformanceFull({
        requestBody,
    }: {
        requestBody: PerformanceFullCreateRequest,
    }): CancelablePromise<PerformanceFullResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/performance/full',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update Performance Full
     * 성과 전체 업데이트
     *
     * Performance와 PerformanceItems를 한번에 업데이트합니다.
     * Items에 대해 지능형 CRUD 처리:
     * - id 있음: UPDATE (기존 항목 수정)
     * - id 없음: CREATE (새 항목 추가)
     * - DB에 있으나 요청에 없음: DELETE (항목 삭제)
     *
     * Args:
     * performance_id: 업데이트할 Performance ID
     * data: 성과 전체 업데이트 요청 데이터
     *
     * Returns:
     * PerformanceFullResponse: 업데이트된 성과의 전체 정보
     * @returns PerformanceFullResponse OK
     * @throws ApiError
     */
    public static appsPerformanceViewsUpdatePerformanceFull({
        performanceId,
        requestBody,
    }: {
        performanceId: string,
        requestBody: PerformanceFullUpdateRequest,
    }): CancelablePromise<PerformanceFullResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/performance/full/{performance_id}',
            path: {
                'performance_id': performanceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create Performance
     * 성과 생성
     *
     * 새로운 성과를 생성합니다.
     * @returns PerformanceResponse Created
     * @throws ApiError
     */
    public static appsPerformanceViewsCreatePerformance({
        requestBody,
    }: {
        requestBody: PerformanceCreateRequest,
    }): CancelablePromise<PerformanceResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/performance',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List Performances
     * 성과 목록 조회 및 검색
     *
     * 성과를 페이징하여 조회합니다. 검색 키워드가 제공되면 검색을 수행합니다.
     *
     * Args:
     * assignee_id: 담당자 ID로 필터링 (선택사항)
     * department_id: 부서 ID로 필터링 (선택사항)
     * q: 검색 키워드 (선택사항) - 성과명, 단위로 검색
     * @returns PaginatedResponse_PerformanceResponse_ OK
     * @throws ApiError
     */
    public static appsPerformanceViewsListPerformances({
        assigneeId,
        departmentId,
        q,
        page = 1,
        perPage = 100,
    }: {
        assigneeId?: string,
        departmentId?: string,
        q?: string,
        page?: number,
        perPage?: number,
    }): CancelablePromise<PaginatedResponse_PerformanceResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/performance',
            query: {
                'assignee_id': assigneeId,
                'department_id': departmentId,
                'q': q,
                'page': page,
                'per_page': perPage,
            },
            errors: {
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Performance
     * 성과 조회
     *
     * ID로 특정 성과를 조회합니다.
     * @returns PerformanceResponse OK
     * @throws ApiError
     */
    public static appsPerformanceViewsGetPerformance({
        performanceId,
    }: {
        performanceId: string,
    }): CancelablePromise<PerformanceResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/performance/{performance_id}',
            path: {
                'performance_id': performanceId,
            },
            errors: {
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update Performance
     * 성과 정보 수정
     *
     * 특정 성과의 정보를 수정합니다.
     * @returns PerformanceResponse OK
     * @throws ApiError
     */
    public static appsPerformanceViewsUpdatePerformance({
        performanceId,
        requestBody,
    }: {
        performanceId: string,
        requestBody: PerformanceUpdateRequest,
    }): CancelablePromise<PerformanceResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/performance/{performance_id}',
            path: {
                'performance_id': performanceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete Performance
     * 성과 삭제
     *
     * 특정 성과를 삭제합니다. (소프트 삭제)
     * @returns void
     * @throws ApiError
     */
    public static appsPerformanceViewsDeletePerformance({
        performanceId,
    }: {
        performanceId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/performance/{performance_id}',
            path: {
                'performance_id': performanceId,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
